import { Listar } from './';
// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html


export default {
  path: 'parametros-sistema',
  name: 'Parametros sistema',
  childRoutes: [
    { path: 'listar', name: 'Listar', component: Listar, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/parametros-sistema/route.js